// custom fonts

export const fonts = {
    brand: "Modernist, system-ui, sans-serif",
    body: "Inter,sans-serif",
    heading: "Inter, sans-serif",
}
